module.exports = __webpack_public_path__ + "img/green-circular-row.jpg";